<script setup lang="ts">
  import VideoPlayer from '~/components/media/VideoPlayer.vue'

  defineProps({
    src: {
      type: String,
      required: true,
    },

    posterSrc: String,
    mediaId: String,
  })
</script>

<template>
  <VideoPlayer
    :src
    :poster-src
    :media-id
  />
</template>
